<vectronic-card
  class="are-you-sure"
  [title]="'Are you sure?'"
  [displayClose]="true"
  (closed)="dialogRef.close()"
>
  <ng-container body>
    <p class="are-you-sure__subtitle">
      {{ data.text }}
    </p>
    <div class="are-you-sure__button-container">
      <button mat-button type="submit" color="accent" [mat-dialog-close]="true">
        <mat-icon>check_circle</mat-icon>
        Yes
      </button>
      <button mat-button type="reset" color="warn" [mat-dialog-close]="false">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
    </div>
  </ng-container>
</vectronic-card>
